import { List } from "ant-design-vue";
const { Item, ...other } = List;
import NewList from "./src/index.vue";
const YwList = {
	...other,
	name: "YwList",
	Item: {
		...Item,
		name: "YwListItem",
		Meta: {
			...Item.Meta,
			name: "YwListItemMeta",
		},
	},
};

YwList.install = function (Vue) {
	// Vue.component(YwList.name, List);
	Vue.component(YwList.name, NewList)
	Vue.component(YwList.Item.name, List.Item);
	Vue.component(YwList.Item.Meta.name, List.Item.Meta);
};
export default YwList;
